import { defineMessagesSimple } from '@atlassiansox/bxpkit-core';

const ID_PREFIX = 'WacSignupForm';

export const messages = defineMessagesSimple(ID_PREFIX, {
  socialSignUpOr: 'OR',
  socialSignUpOrSignUpWith: 'Or sign up with',
  loggedOutHeader: 'Get Started',
  loggedOutSubHeader: 'Free for up to 10 users'
});
